import { normalizePlainCityToken } from '@/lib/locationRegions'

/** Eligible-artist count needed for a city to appear in filters, unless listed below. */
export const MIN_ELIGIBLE_ARTISTS_PER_CITY_FOR_FILTER = 10

/**
 * Cities that appear in location filters with 1…(min−1) eligible artists, and are merged into pickers at 0 eligible artists.
 * Every other city needs {@link MIN_ELIGIBLE_ARTISTS_PER_CITY_FOR_FILTER}+. Edit here only (no country blocks).
 */
export const CITIES_ALLOWED_UNDER_MIN_ELIGIBLE_ARTISTS = [
  'Tallinn',
  'The Hague',
  'Rotterdam',
  'Utrecht',
  'Eindhoven',
  'Haarlem',
] as const

export function isCityAllowedUnderMinEligibleArtists(rawCity: string): boolean {
  const canon = normalizePlainCityToken(rawCity.trim())
  if (!canon) return false
  const n = canon.toLowerCase()
  return (CITIES_ALLOWED_UNDER_MIN_ELIGIBLE_ARTISTS as readonly string[]).some(
    (c) => normalizePlainCityToken(c).toLowerCase() === n,
  )
}

export function cityPassesEligibleArtistThreshold(city: string, eligibleCount: number): boolean {
  if (eligibleCount < 1) return false
  if (eligibleCount >= MIN_ELIGIBLE_ARTISTS_PER_CITY_FOR_FILTER) return true
  return isCityAllowedUnderMinEligibleArtists(city)
}
